var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWelcome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 115,
    viewBox: "0 0 163 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 79.7959,
    cy: 57.5,
    r: 57.5,
    fill: "#F8B400",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5847 56.3262V58.3741",
    stroke: "#005555",
    strokeWidth: 0.930952,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1717 59.2383H38.4651",
    stroke: "#005555",
    strokeWidth: 0.930952,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8251 59.2383H35.1169",
    stroke: "#005555",
    strokeWidth: 0.930952,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5847 60.2324V62.2804",
    stroke: "#005555",
    strokeWidth: 0.930952,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8398 24.6426V26.6905",
    stroke: "#005555",
    strokeWidth: 0.930952,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4268 27.5547H53.7202",
    stroke: "#005555",
    strokeWidth: 0.930952,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0802 27.5547H50.3721",
    stroke: "#005555",
    strokeWidth: 0.930952,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8398 28.5488V30.5968",
    stroke: "#005555",
    strokeWidth: 0.930952,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M120.901 77.4492V79.4972",
    stroke: "#005555",
    strokeWidth: 0.930952,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M123.488 80.3613H121.781",
    stroke: "#005555",
    strokeWidth: 0.930952,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M120.142 80.3613H118.433",
    stroke: "#005555",
    strokeWidth: 0.930952,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M120.901 81.3535V83.4015",
    stroke: "#005555",
    strokeWidth: 0.930952,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4011 92.7051V94.753",
    stroke: "#005555",
    strokeWidth: 0.930952,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9881 95.6172H64.2815",
    stroke: "#005555",
    strokeWidth: 0.930952,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6415 95.6172H60.9333",
    stroke: "#005555",
    strokeWidth: 0.930952,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4011 96.6113V98.6593",
    stroke: "#005555",
    strokeWidth: 0.930952,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6885 41.5918C37.5456 42.6693 75.0982 57.1085 74.4517 106.245",
    stroke: "#005555",
    strokeWidth: 0.969795,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1272 72.9297C18.6864 67.8079 38.0618 63.6762 56.8262 71.6513",
    stroke: "#005555",
    strokeWidth: 0.969795,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M103.178 72.9297C113.737 67.8079 133.113 63.6762 151.877 71.6513",
    stroke: "#005555",
    strokeWidth: 0.969795,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M140.729 41.5918C121.872 42.6693 84.3195 57.1085 84.966 106.245",
    stroke: "#005555",
    strokeWidth: 0.969795,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7959 107.959L79.7959 24.6426",
    stroke: "#005555",
    strokeWidth: 0.969795,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M9.51761 31.2734C9.81471 30.5998 10.8002 30.6999 10.9558 31.4195L11.6866 34.8C11.7562 35.1218 12.0251 35.3622 12.3526 35.3955L15.7935 35.7451C16.526 35.8195 16.7353 36.7877 16.099 37.158L13.1098 38.8977C12.8252 39.0633 12.6796 39.3933 12.7492 39.7151L13.4801 43.0957C13.6356 43.8152 12.7795 44.3135 12.2307 43.8228L9.65239 41.5174C9.40696 41.298 9.04812 41.2615 8.76357 41.4271L5.77433 43.1669C5.13804 43.5372 4.39962 42.8769 4.69672 42.2033L6.09248 39.0388C6.22535 38.7376 6.14914 38.3851 5.9037 38.1656L3.3254 35.8603C2.77659 35.3696 3.17634 34.4633 3.90877 34.5377L7.3497 34.8872C7.67725 34.9205 7.98898 34.7391 8.12185 34.4379L9.51761 31.2734Z",
    fill: "#F8B400",
    fillOpacity: 0.37,
    stroke: "#005555",
    strokeWidth: 0.759971
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M154.36 31.3908C155.071 31.1965 155.614 32.0245 155.154 32.599L152.991 35.2981C152.785 35.555 152.768 35.9153 152.949 36.1905L154.848 39.0814C155.252 39.6967 154.633 40.4697 153.944 40.2095L150.709 38.9868C150.401 38.8704 150.053 38.9655 149.847 39.2225L147.684 41.9216C147.224 42.4961 146.297 42.1459 146.332 41.4105L146.495 37.9557C146.511 37.6269 146.313 37.3254 146.005 37.209L142.77 35.9863C142.081 35.726 142.128 34.7366 142.838 34.5423L146.174 33.6299C146.491 33.543 146.717 33.2615 146.732 32.9327L146.896 29.4779C146.93 28.7425 147.886 28.4812 148.29 29.0965L150.189 31.9874C150.369 32.2626 150.707 32.3901 151.024 32.3032L154.36 31.3908Z",
    fill: "#F8B400",
    fillOpacity: 0.37,
    stroke: "#005555",
    strokeWidth: 0.759971
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0511 8.31854C86.787 8.33781 87.0683 9.28757 86.4616 9.70456L83.6113 11.6636C83.3399 11.85 83.2195 12.19 83.313 12.5057L84.2954 15.8219C84.5044 16.5278 83.6881 17.0889 83.104 16.6407L80.3601 14.5352C80.0989 14.3348 79.7384 14.3254 79.467 14.5118L76.6167 16.4708C76.0099 16.8878 75.2241 16.2848 75.4698 15.5908L76.6243 12.3306C76.7342 12.0202 76.6318 11.6744 76.3706 11.474L73.6267 9.3685C73.0426 8.92033 73.3733 7.98659 74.1092 8.00586L77.5667 8.09639C77.8958 8.10501 78.193 7.90071 78.3029 7.59036L79.4574 4.3301C79.7032 3.63612 80.6934 3.66205 80.9025 4.36794L81.8848 7.68415C81.9783 7.99983 82.2645 8.21939 82.5936 8.22801L86.0511 8.31854Z",
    fill: "#F8B400",
    fillOpacity: 0.37,
    stroke: "#005555",
    strokeWidth: 0.759971
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.43336,
    cy: 76.2747,
    r: 2.34694,
    fill: "#F8B400",
    fillOpacity: 0.37,
    stroke: "#005555",
    strokeWidth: 0.821429
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 159.505,
    cy: 76.2747,
    r: 2.34694,
    fill: "#F8B400",
    fillOpacity: 0.37,
    stroke: "#005555",
    strokeWidth: 0.821429
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcome);
export default __webpack_public_path__ + "static/media/welcome.bdfe62d05f611037705abbaa4524c3f3.svg";
export { ForwardRef as ReactComponent };